// extracted by mini-css-extract-plugin
module.exports = {"controls":"wdJZMS","reset":"s4f3wk"};